import { configureStore } from '@reduxjs/toolkit';
import modelReducer from './slices/modelSlice';
import coworkReducer from './slices/coworkSlice';
import quickActionReducer from './slices/quickActionSlice';
import scheduledTaskReducer from './slices/scheduledTaskSlice';
import logReducer from './slices/logSlice';
import dashboardReducer from './slices/dashboardSlice';
import flowReducer from './slices/flowSlice';
import alertConfigReducer from './slices/alertConfigSlice';

export const store = configureStore({
  reducer: {
    model: modelReducer,
    cowork: coworkReducer,
    quickAction: quickActionReducer,
    scheduledTask: scheduledTaskReducer,
    logManager: logReducer,
    dashboard: dashboardReducer,
    flow: flowReducer,
    alertConfig: alertConfigReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;